import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-453af0a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "parent-container" }
const _hoisted_2 = { class: "shortcuts-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shortcut-title" }, "Kategorier", -1))
const _hoisted_4 = { class: "shortcut-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "shortcuts-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shortcut-title" }, "Kalender", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleCalendar = _resolveComponent("SimpleCalendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indlaegkategoris, (category, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "shortcut-item",
              onClick: ($event: any) => (_ctx.goToCategory(category.indlaeg_kategori_titel))
            }, [
              _createElementVNode("a", null, _toDisplayString(category.indlaeg_kategori_titel), 1)
            ], 8, _hoisted_5))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(_component_SimpleCalendar)
    ])
  ]))
}